import { Button, ButtonGroup, buttonName, useItemNames } from '@ps-smart-cp/ppfw-client';

interface Props {
  onRegister: () => void;
  onReset: () => void;
}

export function RegisterAndResetButtonGroup({ onRegister, onReset }: Props) {
  const getButtonName = useItemNames(buttonName);

  return (
    <ButtonGroup alignment="right">
      <Button label={getButtonName('register')} onClick={onRegister} />
      <Button label={getButtonName('reset')} onClick={onReset} />
    </ButtonGroup>
  );
}
